export class RecaptchaManager {
    constructor() {
        this.initializeRecaptcha();
    }

    initializeRecaptcha() {
        setTimeout(() => {
            const head = document.getElementsByTagName('head')[0];
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
            head.appendChild(script);
        }, 3000);

        window.onloadCallback = this.onloadCallback;
    }

    onloadCallback() {
        $('.g-recaptcha').each(function() {
            const object = $(this);

            try {
                if (object.data().hasOwnProperty('sitekey')) {
                    let sitekey = object.data('sitekey');

                    grecaptcha.render(object.attr('id'), {
                        sitekey: sitekey,
                        callback: function(token) {
                            console.log(token);
                            object.parents('form').find('.g-recaptcha-response').val(token);
                            object.parents('form').submit();
                        }
                    });
                }
            } catch (error) {
                console.log(error);
            }
        });
    }
}
